if (!window.Eurus) window.Eurus = { loadedScript: new Set() };
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('try-before-you-buy.js')) {
  window.Eurus.loadedScript.add('try-before-you-buy.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xTryBeforeYouBuy', (config) => ({
        sectionId: config.sectionId,
        currencyFormat: config.currencyFormat,
        maxSelectable: config.maxSelectable || 2,
        minSelectable: config.minSelectable || 1,
        trialDays: config.trialDays || 14,
        redirectTo: config.redirectTo || 'cart-drawer',
        clearCartFirst: config.clearCartFirst === false ? false : true,
        selected: {},
        products: {},
        loading: false,
        errorMessage: '',

        bootTbyb(rootEl) {
          const cards = rootEl.querySelectorAll('script[data-tbyb-product]');
          cards.forEach((scriptEl) => {
            const blockId = scriptEl.getAttribute('data-tbyb-product');
            try {
              this.products[blockId] = JSON.parse(scriptEl.textContent);
              this.selected[blockId] = false;
            } catch (e) {
              console.warn('[tbyb] failed to parse product block', blockId, e);
            }
          });
        },

        get selectedBlockIds() {
          return Object.keys(this.products).filter((id) => this.selected[id]);
        },

        get selectedCount() {
          return this.selectedBlockIds.length;
        },

        get hasSelection() {
          return this.selectedCount > 0;
        },

        get canSubmit() {
          return this.selectedCount >= this.minSelectable;
        },

        get atLimit() {
          return this.selectedCount >= this.maxSelectable;
        },

        get payToday() {
          // Only "shipping" is paid today via Mirra. Display intentionally empty/placeholder.
          // If you want to show product subtotal here, replace with the sum of basePrice * 1.
          return this.formatMoney(0);
        },

        toggleSelect(blockId, evt) {
          if (this.selected[blockId]) {
            this.selected[blockId] = false;
            this.errorMessage = '';
            return;
          }
          if (this.atLimit) {
            if (evt && evt.target) evt.target.checked = false;
            this.errorMessage = `You can try up to ${this.maxSelectable} products per trial.`;
            return;
          }
          this.selected[blockId] = true;
          this.errorMessage = '';
        },

        formatMoney(cents) {
          if (Alpine.store('xHelper') && typeof Alpine.store('xHelper').formatMoney === 'function') {
            return Alpine.store('xHelper').formatMoney(cents, this.currencyFormat);
          }
          try {
            const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
          } catch (e) {
            return '$' + (cents / 100).toFixed(2);
          }
        },

        async handleAddToCart(el) {
          if (this.loading) return;
          if (!this.canSubmit) {
            this.errorMessage = this.minSelectable > 1
              ? `Please pick at least ${this.minSelectable} products to start your trial.`
              : 'Please pick at least one product to start your trial.';
            return;
          }
          this.errorMessage = '';

          // Mirra recognises a trial item by its "Try with Mirra" selling plan
          // (selling_plan on the cart line), not by a line item property. The
          // plan id is resolved per product in the section Liquid.
          const items = this.selectedBlockIds.map((id) => {
            const p = this.products[id];
            if (!p) return null;
            const item = { id: p.id, quantity: 1 };
            if (p.sellingPlanId) {
              item.selling_plan = p.sellingPlanId;
            } else {
              console.warn('[tbyb] no "Try with Mirra" selling plan for', p.title, '— item will NOT be treated as a trial');
            }
            return item;
          }).filter(Boolean);

          if (!items.length) {
            this.errorMessage = 'No products available for trial.';
            return;
          }

          this.loading = true;
          const cartHelper = Alpine.store('xCartHelper');
          if (cartHelper && typeof cartHelper.waitForCartUpdate === 'function') {
            await cartHelper.waitForCartUpdate();
          }
          window.updatingCart = true;

          try {
            if (this.clearCartFirst) {
              const clearResponse = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
              });
              if (!clearResponse.ok) {
                this.errorMessage = 'Could not prepare your cart. Please try again.';
                return;
              }
            }

            // Request the cart sections in the add response so we can re-render
            // the drawer with fresh contents (otherwise it opens showing stale,
            // empty markup until a page refresh).
            let sectionIds = [];
            if (cartHelper && typeof cartHelper.getSectionsToRender === 'function') {
              sectionIds = cartHelper.getSectionsToRender().map((s) => s.id);
            }
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items, sections: sectionIds })
            });
            const data = await response.json();

            if (!response.ok || data.status === 422 || data.status === '422') {
              this.errorMessage = data.description || data.message || 'Could not start your trial. Please try again.';
              return;
            }

            // Re-render the cart drawer/sections from the fresh response BEFORE
            // opening, so the drawer shows the just-added items.
            if (cartHelper && typeof cartHelper.reRenderSections === 'function' && data.sections) {
              cartHelper.reRenderSections(data.sections);
            }

            // Default: open the theme mini-cart drawer (same pattern as
            // subscription-builder / product-bundle). A non-empty redirect URL
            // other than the 'cart-drawer' sentinel navigates instead.
            const miniCart = Alpine.store('xMiniCart');
            if (this.redirectTo && this.redirectTo !== 'cart-drawer') {
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
              window.location.href = this.redirectTo;
            } else if (miniCart && typeof miniCart.openCart === 'function') {
              miniCart.openCart();
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            } else {
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
              window.location.href = '/cart';
            }
          } catch (err) {
            console.error('[tbyb] add-to-cart failed', err);
            this.errorMessage = 'Could not start your trial. Please try again.';
          } finally {
            window.updatingCart = false;
            this.loading = false;
          }
        }
      }));
    });
  });
}
